/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Drawer, IconButton, Step, StepLabel, Stepper, styled, Typography } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { useEffect, useState } from "react";
import { LoadingPage } from "../../../../common/LoadingPage";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { useSelector } from "react-redux";
import ProductDetails from "./ProductDetails";
import Catalog from "../../Catalog/catalog";
import CommonDestination from "./CommonDestination";
import { ActionStage, ItemStatus, Scope } from "../../../../common/const";
import { apiRequest } from "../../../../common/common";

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const steps = ['Select Item', 'Item Details', 'Choose/Review Destination(s)'];

const CreateItemFromCatalog = ({
    cataLogOpen,
    setCatalogOpen,
    projectData,
    room,
    onGridReady
}) => {
    const { user } = useSelector(state => state.users);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [item, setItem] = useState({});
    const [tableData, setTableData] = useState([]);

    const handleClose = () => {
        setCatalogOpen(false);
        setItem(null);
        setActiveStep(0);
        setSelectedProduct([]);
    }

    const handleSubmit = async () => {
        if (tableData?.length > 0) {
            setDataLoading(true);
            try {
                item.room_data = JSON.stringify(
                    tableData?.map((a) => ({
                      room_id: a.room_id,
                      quantity: a.quantity || 1
                    }))
                );
                const response = await apiRequest('post', '/project-item/from-catalog', item);
                if (response.data) {
                    handleClose();
                    onGridReady();
                    showNotification(response.data.message, 'success');
                } 
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else {
            showNotification('Please select destination before proceed', 'error');
        }
    }

    const handleNext = () => {
        if (activeStep === 0 && selectedProduct.length === 0) {
            showNotification('Please select product', 'error');
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    useEffect(() => {
        setItem((prevData) => ({
            ...prevData,
            organization_id: user?.organization?.organization_id,
            created_by: user?.user_id,
            scope: Scope[0]?.value,
            status: ItemStatus[0]?.value,
            stage: ActionStage[0]?.value,
            tax: projectData?.tax_rate,
            funding_source: projectData?.funding_source,
            project_id: projectData?.project_id
        }));
        if (selectedProduct?.length > 0) {
            setItem((prevData) => {
                const selectedProductData = selectedProduct[0];
                const filteredProductData = Object.keys(selectedProductData).reduce((acc, key) => {
                    if (selectedProductData[key] != null) {
                        acc[key] = selectedProductData[key];
                    }
                    return acc;
                }, {});

                return {
                    ...prevData,
                    unit_price: filteredProductData?.list_price,
                    product_data: {
                        furnish_responsibility: filteredProductData?.furnish_responsibility,
                        install_responsibility: filteredProductData?.install_responsibility,
                        architectural_code: filteredProductData?.architectural_code,
                        vendor_id: filteredProductData?.vendor_id,
                        vendor: {
                            name: filteredProductData?.vendor?.name
                        }
                    },
                    product_id: filteredProductData?.product_id,
                };
            });

        }
    }, [selectedProduct]);

    return (
        <Drawer
            anchor="bottom"
            open={cataLogOpen}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '88%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Typography variant='body1' style={{ fontWeight: 'bold' }}>Add Item(s) To Project: {projectData?.name}</Typography>
                <Box>
                    {activeStep > 0 && (
                        <Button variant='outlined' size="small" onClick={() => handleBack()} style={{ marginRight: 5 }}>
                            Back
                        </Button>
                    )}
                    {activeStep < 2 && (
                        <Button variant='contained' size="small" onClick={() => handleNext()}>
                            Next
                        </Button>
                    )}
                    {activeStep === 2 && (
                        <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                            Save
                        </Button>
                    )}
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            <Box sx={{ width: '100%', padding: activeStep !== 2 ? '10px' : '5px 0px 0px 0px' }}>
                <Stepper activeStep={activeStep} style={{ marginBottom: '5px' }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Divider />
            </Box>
            {activeStep === 0 && (
                <Catalog
                    fromTemplate={true}
                    setSelectedProduct={setSelectedProduct}
                />
            )}
            {activeStep === 1 && (
                <ProductDetails
                    projectData={projectData}
                    selectedProduct={selectedProduct}
                    item={item}
                    setItem={setItem}
                />
            )}
            {activeStep === 2 && (
                <CommonDestination
                    projectData={projectData}
                    room={room}
                    tableData={tableData}
                    setTableData={setTableData}
                />
            )}
        </Drawer>
    )
}

export default CreateItemFromCatalog;